import React from "react";

import useProjectCreationDate from "@/src/hooks/useProjectCreationDate";

import DateRangePicker from "../../utils/DateRangePicker";

import type { Moment } from "moment";
import type { JSX } from "react";

import type { AnalyticsPeriod } from "@/src/hooks/usePeriodFilter";

interface AnalyticsPeriodPickerProps {
  period: AnalyticsPeriod;
  onChange: (startDate: Moment, endDate: Moment) => void;
  minDate?: Moment | null;
}

function AnalyticsPeriodPicker({
  period,
  onChange,
  minDate,
}: AnalyticsPeriodPickerProps): JSX.Element {
  const projectCreationDate = useProjectCreationDate();

  return (
    <DateRangePicker
      endDate={period.endDate}
      minDate={minDate ?? projectCreationDate}
      onChange={onChange}
      startDate={period.startDate}
    />
  );
}

export default AnalyticsPeriodPicker;
